import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import BackgroundVideo from "@/components/BackgroundVideo";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[88svh] md:min-h-screen flex items-center overflow-hidden bg-quietcove-blue">
      {/* Background video: our own Javits footage, muted for autoplay */}
      <div className="absolute inset-0 overflow-hidden">
        <BackgroundVideo
          src="/site-video/javits-promo.mp4"
          poster="/site-video/javits-promo-poster.webp"
          className="w-full h-full object-cover hero-drift"
        />
        {/* Legibility scrim, heavier on the left where the copy sits */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/45" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-20 md:pt-32 md:pb-28">
        <div className="max-w-2xl">
          <div className="flex items-center gap-4 mb-7">
            <span className="h-px w-12 bg-gold" />
            <p className="text-white/75 text-xs sm:text-sm font-semibold uppercase tracking-[0.22em]">
              Private workspace by the hour
            </p>
          </div>

          <h1 className="font-display text-[2.6rem] leading-[1.05] sm:text-6xl lg:text-7xl font-bold tracking-[-0.025em] text-white mb-7 text-balance">
            Your quiet corner, wherever work takes&nbsp;you.
          </h1>

          <p className="text-white/85 text-lg md:text-xl leading-relaxed mb-10 max-w-lg">
            Soundproof pods you book and unlock in seconds.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-7">
            <Button
              onClick={() => navigate("/book")}
              className="group bg-gold hover:bg-gold-deep text-white font-bold px-9 py-6 text-lg rounded-xl shadow-lg shadow-black/20 transition-colors duration-300 w-full sm:w-auto"
            >
              Find a pod near you
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>

            <button
              onClick={() =>
                document.getElementById("locations")?.scrollIntoView({ behavior: "smooth" })
              }
              className="text-white/75 hover:text-white text-base font-medium tracking-wide transition-colors duration-200 border-b border-white/25 hover:border-gold pb-0.5"
            >
              See all locations
            </button>
          </div>
        </div>
      </div>

      {/* Where we are, held quietly in the corner */}
      <div className="absolute bottom-7 right-6 lg:right-8 z-10 hidden sm:flex items-center gap-3">
        <span className="h-px w-8 bg-white/35" />
        <span className="text-white/65 text-xs uppercase tracking-[0.2em]">
          Javits Center, New York
        </span>
      </div>
    </section>
  );
};

export default HeroSection;
